import { Routes } from '@angular/router';
import { AuthGuard } from './guard/AuthGuard';
import { CaptchaPageComponent } from './pages/application/pages/captcha-page/captcha-page.component';

export const routes: Routes = [
  // { path: '', redirectTo: 'landing-page', pathMatch:'full' },
  { path: '', component:CaptchaPageComponent},
  { path:'home',
  canActivate:[AuthGuard],
  data:{roles:['NEXTGENAPPS']} ,
  loadChildren:()=>
  import('./pages/general/modules/landing/landing.module').then(root=>root.LandingModule) },
   {path:'dashboard',
   canActivate:[AuthGuard],
   data:{roles:['NEXTGENAPPS']} ,
   loadChildren:()=>
   import('./pages/general/modules/landing/landing.module').then(root=>root.LandingModule),
  },
  {path:'landing-page',
  canActivate:[AuthGuard],
  data:{roles:['NEXTGENAPPS']} ,
  loadChildren:()=>
  import('./pages/general/modules/landing/landing.module').then(root=>root.LandingModule)
 }
    // { path: "login", component: DashboardComponent, 
    // canActivate: [AuthGuard], data: { roles: ["NEXTGENAPPS"]} },

];
